/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartDimensionThresholdResponse
 */
export interface PartDimensionThresholdResponse {
    /**
     * 
     * @type {number}
     * @memberof PartDimensionThresholdResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDimensionThresholdResponse
     */
    partDimensionId?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDimensionThresholdResponse
     */
    minPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDimensionThresholdResponse
     */
    actionTypeId?: number;
}

/**
 * Check if a given object implements the PartDimensionThresholdResponse interface.
 */
export function instanceOfPartDimensionThresholdResponse(value: object): value is PartDimensionThresholdResponse {
    return true;
}

export function PartDimensionThresholdResponseFromJSON(json: any): PartDimensionThresholdResponse {
    return PartDimensionThresholdResponseFromJSONTyped(json, false);
}

export function PartDimensionThresholdResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartDimensionThresholdResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'partDimensionId': json['partDimensionId'] == null ? undefined : json['partDimensionId'],
        'minPercentage': json['minPercentage'] == null ? undefined : json['minPercentage'],
        'actionTypeId': json['actionTypeId'] == null ? undefined : json['actionTypeId'],
    };
}

export function PartDimensionThresholdResponseToJSON(json: any): PartDimensionThresholdResponse {
    return PartDimensionThresholdResponseToJSONTyped(json, false);
}

export function PartDimensionThresholdResponseToJSONTyped(value?: PartDimensionThresholdResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'partDimensionId': value['partDimensionId'],
        'minPercentage': value['minPercentage'],
        'actionTypeId': value['actionTypeId'],
    };
}

